module.exports = __webpack_public_path__ + "static/media/undraw_add_tasks.80e5a843.svg";